import gql from 'graphql-tag'

export const getCreditsUsageForDownloadFileQuery = gql`
  query getCreditsUsageForDownloadFile($recordSize: Int!, $limited: Boolean!) {
    getCreditsUsageForDownloadFile(recordSize: $recordSize, limited: $limited)
  }
`
